import React from 'react';
import PropTypes from 'prop-types';

import AmountSelector from 'components/AmountSelector';

import Description from 'ui/text/Description';
import FormSection from 'ui/FormSection';

import { Checkbox, FormControlLabel, TextField } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';

const Content = ({onEmailChange, tickets, onTicketSelect, ticket, variant, onVariantSelect, amount, onAmountChange, checkedInStatus, onCheckedInStatusChange, itemNoun = "Ticket", checkedInLabel = "Mark as checked in"}) => {

  const noun = itemNoun.toLowerCase();

  if (tickets.length === 0) return <FormSection slim><p>No {noun}s available</p></FormSection>;

  const handleTicketSelection = (event, ticket) => {
    onAmountChange(ticket.min_amount || 1);
    onVariantSelect(null);
    onTicketSelect(ticket);
  };

  // SELL06 — variant products sell per SKU: the picker is required and the
  // quantity is capped by the selected SKU's event availability.
  const variants = ticket?.variants || [];
  const hasVariants = variants.length > 0;
  const maxAmount = hasVariants ? variant?.available_amount : ticket.available_amount;

  const handleEmailChange = ({target: {value}}) => {
    onEmailChange(value);
  };

  const handleCheckBoxChange = ({target: {checked}}) => {
    onCheckedInStatusChange(checked);
  };

  return (
    <FormSection slim>
      <Description>
        Select {noun} and quantity, and optionally enter an email to link to the sale.
      </Description>

      <Autocomplete
        fullWidth
        options={tickets}
        onChange={(event, newValue) => {
          handleTicketSelection(event, newValue);
        }}
        disabled={tickets.length === 1}
        defaultValue={tickets.find((element) => element.id === ticket?.id)}
        getOptionLabel={(option) => `${option.identifier} ${option.available_amount ? ' (' + option.available_amount + ' left)' : ''}`}
        disableClearable
        renderInput={(params) => (
            <TextField
                {...params}
                label={itemNoun}
                name="ticket"
                fullWidth
                size='small'
                color="warning"
            />
        )}
      />

      <>
        {hasVariants &&
          <Autocomplete
            fullWidth
            options={variants}
            value={variant}
            onChange={(event, newValue) => {
              onAmountChange(ticket.min_amount || 1);
              onVariantSelect(newValue);
            }}
            getOptionLabel={(option) => `${option.label}${option.available_amount != null ? ' (' + option.available_amount + ' left)' : ''}`}
            getOptionDisabled={(option) => !option.available}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            disableClearable
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Option"
                    name="variant"
                    fullWidth
                    size='small'
                    color="warning"
                />
            )}
          />
        }

        <AmountSelector 
          amount={amount} 
          maxAmount={maxAmount} 
          onAmountChange={onAmountChange}
          minAmount={ticket.min_amount}
        />

        <FormControlLabel
          sx={{ mt: -1 }}
          control={
            <Checkbox checked={checkedInStatus}
                      onChange={handleCheckBoxChange}
                      size='small'
            />
          }
          label={checkedInLabel}
        />

        <TextField
          label={'Add Email (Optional)'}
          name="email"
          onChange={handleEmailChange}
          fullWidth
          size='small'
          color="warning"
        />
      </>

    </FormSection>
  );
};

Content.propTypes = {
  onEmailChange: PropTypes.func,
  tickets: PropTypes.array,
  onTicketSelect: PropTypes.func,
  ticket: PropTypes.object,
  variant: PropTypes.object,
  onVariantSelect: PropTypes.func,
  amount: PropTypes.number,
  onAmountChange: PropTypes.func,
  checkedInStatus: PropTypes.bool,
  onCheckedInStatusChange: PropTypes.func,
  itemNoun: PropTypes.string,
  checkedInLabel: PropTypes.string
};

export default Content;
